// extracted by mini-css-extract-plugin
export var arrow = "DocumentFilesDropdown-module--arrow--c8ac7";
export var arrowNo = "DocumentFilesDropdown-module--arrow_no--1eb50";
export var arrowYes = "DocumentFilesDropdown-module--arrow_yes--ae49a";
export var documentFilesDropdown = "DocumentFilesDropdown-module--documentFilesDropdown--603b5";
export var documentInformation = "DocumentFilesDropdown-module--documentInformation--ba16c";
export var documentTitle = "DocumentFilesDropdown-module--documentTitle--e95a6";
export var downloadIcon = "DocumentFilesDropdown-module--downloadIcon--c5402";
export var dropDownItemSeparator = "DocumentFilesDropdown-module--dropDownItemSeparator--9c157";
export var dropdownChevronIcon = "DocumentFilesDropdown-module--dropdownChevronIcon--70fbc";
export var dropdownHeader = "DocumentFilesDropdown-module--dropdownHeader--c1250";
export var dropdownItem = "DocumentFilesDropdown-module--dropdownItem--3e290";
export var dropdownItems = "DocumentFilesDropdown-module--dropdownItems--852a9";
export var dropdownTitle = "DocumentFilesDropdown-module--dropdownTitle--d45d2";
export var externalLinkIcon = "DocumentFilesDropdown-module--externalLinkIcon--83a4c";
export var fileInformation = "DocumentFilesDropdown-module--fileInformation--b5bb1";
export var flex = "DocumentFilesDropdown-module--flex--414db";
export var flex1 = "DocumentFilesDropdown-module--flex_1--ef46d";
export var flexCenter = "DocumentFilesDropdown-module--flex_center--3e9ef";
export var flexCenterCol = "DocumentFilesDropdown-module--flex_center_col--d9540";
export var flexCol = "DocumentFilesDropdown-module--flex_col--abaa8";
export var flexFixCenterCol = "DocumentFilesDropdown-module--flex_fix_center_col--9680c";
export var flexFixedCenterCol = "DocumentFilesDropdown-module--flex_fixed_center_col--fda21";
export var open = "DocumentFilesDropdown-module--open--10b00";
export var rotating = "DocumentFilesDropdown-module--rotating--51a4a";
export var textFileIcon = "DocumentFilesDropdown-module--textFileIcon--90d24";